import { handleActions } from 'redux-actions';
import { put, takeEvery } from 'redux-saga/effects';

import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';
import getCRUDSagas from '../../utils/redux/getCRUDSagas';

import * as commonActionHandlers from '../../utils/redux/commonActionHandlers';

import Api from '../../utils/resourcesApi';

// The import queue (FIN-1281) — the plain CRUD list feature, paged, filtered and searched
// on the server. The CARD of one import is a page of its own (./Reconcile) reading the
// resource directly, like the recurring template does.
export const constants = getConstantsByFeatureName('INVOICE_IMPORTS');

export const actions = getActionCreators(constants);

const initialState = {
  ...commonActionHandlers.initialState,
  // The queue opens on what still waits for somebody.
  filter: { awaiting: true },
};

export const reducer = handleActions(getActionHandlers(constants), initialState);

export const selector = getSelectorByFeatureName('invoiceImports');

const crudSagas = getCRUDSagas(
  '/invoice_imports',
  Api.invoiceImports,
  actions,
  constants,
  'invoiceImports',
  'invoiceImports',
);

// FIN-1300: the companies picked in the header are a setting, like the invoices' — the
// list re-reads itself when they change.
function* reloadOnCompanies() {
  yield put(actions.loadItemsRequest());
}

export const sagas = () => [
  ...crudSagas(),
  takeEvery('@SETTINGS/GLOBAL/SET_IMPORT_COMPANIES', reloadOnCompanies),
];
